import { render, staticRenderFns } from "./BannerPicture.vue?vue&type=template&id=6d8a52da&scoped=true&"
import script from "./BannerPicture.vue?vue&type=script&lang=js&"
export * from "./BannerPicture.vue?vue&type=script&lang=js&"
import style0 from "./BannerPicture.vue?vue&type=style&index=0&id=6d8a52da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8a52da",
  null
  
)

export default component.exports